import { render, staticRenderFns } from "./TransactionCategorySettings.vue?vue&type=template&id=4f9f305c&"
import script from "./TransactionCategorySettings.vue?vue&type=script&lang=js&"
export * from "./TransactionCategorySettings.vue?vue&type=script&lang=js&"
import style0 from "./TransactionCategorySettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VCard,VIcon,VTextField,VTreeview})
